import TextField from '@mui/material/TextField'
import { object, func } from 'prop-types'
import { t } from '@lingui/core/macro'

export const Constant = ({ form, setForm, disabled }) => {
  return (
    <TextField
      name="constant"
      margin="dense"
      disabled={disabled}
      variant="outlined"
      value={form.constant_value}
      onChange={({ target: { value } }) => setForm(prev => ({ ...prev, constant_value: value }))}
      label={t`Value`}
    />
  )
}

Constant.propTypes = {
  form: object.isRequired,
  setForm: func.isRequired,
}
